export const productMenu = {
	all: "Todos los productos",
	activedProducts: "Productos activos",
	inactivedProducts: "Productos inactivos",
	isDisabledMenu: "Los menús principales no pueden ser editados o eliminados",
	legacyMenuTag: "Legado",
	legacyMenuTooltip: "Este menú es de la versión anterior y ya no se puede editar.",
	defaultMenuName: "Menú Principal",
	tooltipActive: "Menú activo",
	tooltipInactive: "Menú inactivo",
	tooltipMenuType: "Menú del tipo",
	info: {
		product: "producto",
		products: "productos",
	},
	manageMenu: "Gestión de menús",
	manageBars: "Bares",
	manageProducts: "Gestión de productos",
	newMenu: "Nuevo menú",
	createNewMenu:
		"Cree, edite y gestione menús con estado, activando o desactivando según la demanda.",
	requiredField: "Campo Obligatorio",
	menuName: "Nombre del menú duplicado",
	duplicateMenu: "Duplicar Menú",
	editMenu: "Editar Menú",
	closeAction: "Cerrar",
	addProducts: "Agregar Productos",
	newMenuName: "Nombre del Menú",
	duplicateMenuError:
		"Ya existe un menú de este tipo activo. Solo puede existir un menú activo por tipo.",
	menus: "Menús",
	status: "Estado",
	type: "Tipo",
	createFirstMenu: "Cree su primer menú ahora",
	createMenuInstructions: "Cree ahora su primer menú y vincule productos y precios.",
	createMenu: "Crear Menú",
	duplicate: "Duplicar",
	delete: "Eliminar",
	edit: "Editar",
	deleteMenu: "Eliminar Menú",
	confirmDelete:
		"¿Desea eliminar el {{menuName}}? Toda la información será eliminada y esta acción no podrá deshacerse.",
	active: "Activo",
	inactive: "Inactivo",
	confirmDuplicateMenu:
		"¿Desea duplicar {{menuName}}? Toda la información de la réplica será idéntica al original, pero no estará vinculada a ningún área.",
	menuType: {
		normal: "Normal",
		delivery: "Delivery",
		dineIn: "Pedido en mesa",
		hawker: "Ambulante",
		grabAndGo: "Grab and Go",
		onlineFicha: "Ficha Digital",
		pickUp: "Retirada",
		deliveryByMarketplace: "Entrega por el restaurante",
		onlineTab: "Comanda online",
		viewMenu: "Menú digital",
		deliveryIntegrated: "Delivery Integrado",
		digital: "Menú Digital",
	},
	activateMenu: "Activar Menú",
	deactivateMenu: "Desactivar Menú",
	importProducts: "A partir de importación de productos",
	importWithSheet:
		"Utilice hoja de cálculo para importar nuevos productos automáticamente",
	linkExistingProducts: "Vincular productos existentes",
	selectImportedProducts:
		"Seleccione productos ya importados para vincularlos al nuevo menú",
	importCategoriesProducts:
		"Se importarán y crearán categorías y productos. Si el producto ya existe, será duplicado en esta importación.",
	emptyText: {
		title: "Aún no hay nada por aquí",
		description: "Comience vinculando categorías, y luego los productos al menú.",
	},
	menuTypeLabel: "Tipo de Menú",
	downloadSampleSheet: "Haga clic aquí para descargar la hoja de cálculo de ejemplo",
	clickToAddSheet: "Haga clic para agregar hoja de cálculo",
	importSheet: "Importar Hoja de Cálculo",
	importProductsTitle: "Importar Productos",
	emptyRowsWarning: "Su hoja de cálculo contiene filas vacías",
	linkProductsToMenu: "Vincular productos al menú",
	noProductFound: "Ningún producto encontrado",
	enterNewMenuName: "Ingrese el nombre del nuevo menú",
	selectMenuType: "Seleccione el tipo de menú",
	addProductsCount: "Agregar {{products}} productos",
	selectProductsToLink: "Seleccione los productos que desea vincular al nuevo menú",
	loadingProducts: "Cargando productos",
	fileLoadError:
		"No pudimos cargar su archivo. Por favor, confirme si el archivo fue guardado correctamente e intente nuevamente",
	loadingSheet: "Cargando hoja de cálculo",
	invalidRowsError: "Filas inválidas, verifique las siguientes columnas: {{rows}}",
	linkProductToMenu: "Vincular producto",
	createProduct: "Crear Producto",
	confirmRemoveProdutFromMenu:
		"¿Desea desvincular {{productName}} del menú? Si existen informaciones editadas de precio, las perderá. Si solo quiere desactivar el producto del menú, puede hacer clic en la llave de estado en la tabla de productos del menú.",
	removeProductFromMenu: "Desvincular producto del menú",
	confirmRemoveProductFromMenuLabel: "Desvincular producto",
	revertProductPriceTitle: "Deshacer cambio de precio",
	confirmRevertProductPriceDescription:
		"Al confirmar esta acción, volverá al precio del producto, descartando el cambio hecho previamente. El precio del producto son los precios definidos en la sección 'Gestión de Producto'.",
	editProductTitle: "Editar {{productName}}",
	category: "Categoría",
	price: "Precio",
	saveChanges: "Guardar Cambios",
	editMenuProduct: "Editar producto en el menú",
	yes: "Sí",
	no: "No",
	positivePriceErrorMessage: "El precio debe ser un valor positivo",
	viewProductPage: "Ver Página del Producto",
	product: "Producto",
	mountable: "Montable",
	searchProduct: "Buscar Producto",
	importWithSheetToMenu:
		"Utilice hoja de cálculo para importar nuevos productos automáticamente al menú",
	createProductFromScratch: "Crear producto desde cero",
	createNewProduct: "Cree un nuevo producto llenando todos los datos necesarios",
	selectProductsToLinkToMenu: "Seleccione los productos que desea vincular al menú",
	addProductsToMenu: "Agregue productos al menú",
	emptyMenu: "Menú vacío",
	addProductsToStartUsingIt: "Agregue productos para comenzar a usar",
	sku: "SKU",
	nameMaxLength: "Límite de {{maxLength}} caracteres excedido",
	menuCreated: "Menú creado con éxito",
	menuUpdated: "Menú editado con éxito",
	menuRemoved: "Menú eliminado con éxito",
	menuDuplicated: "Menú duplicado",
	menuStatusChanged: "Estado del menú cambiado",
	menuProductPriceChanged:
		"El precio de {{productName}} fue cambiado con éxito en {{menuName}}",
	menuProductUpdated:
		"El producto {{productName}} fue actualizado con éxito en {{menuName}}",
	menuProductRemoved:
		"El producto {{productName}} fue eliminado con éxito de {{menuName}}",
	productsAmountAtMenu: "cant. de productos",
	products: "producto(s)",
	allCategories: "Todas las categorías",
	filters: {
		all: "Todos",
		filterByName: "Filtrar por nombre",
		filterByMenuType: "Filtrar por tipo de menú",
		allMenuTypes: "Todos los tipos",
		filterByLinkedBars: "Filtrar por bares vinculados",
		activeFilters: "Filtros activos",
		clearAll: "Limpiar todos los filtros",
		noResults: "Ningún resultado encontrado con los filtros actuales",
		clearFilters: "Limpiar filtros",
	},
	createMenuModal: {
		menuNameLabel: "Nombre del menú",
		menuNamePlaceholder: "Nombre el menú",
		title: "Agregar menú",
	},
	editMenuModal: {
		title: "Editar menú",
	},
	bars: "Bares",
	barsByVendor: {
		vendorsLabel: "Vendors",
		otherBarsLabel: "Otros bares",
		summary: "{{total}} bares · {{selected}} seleccionados",
	},
	dashboard: {
		productCount: "Cant. de productos",
		categoryCount: "Categorías",
		barCount: "Bares",
	},
	linkProductsDrawer: {
		categories: "Categorías",
		itemsSelected: "elementos seleccionados",
		newlySelected: "Seleccionado",
		alreadyAdded: "Agregado",
		addAllProducts: "Agregar Todos los Productos",
		linkProducts: "Vincular productos",
		title: "Vincular productos",
		successMessage: "Producto(s) vinculado al menú con éxito",
		typeToSearch: "Digite para buscar",
		noProductFound: "Ningún producto encontrado",
		product: "Producto",
		sku: "SKU",
		closeAction: "Cerrar",
		saveChanges: "Guardar Cambios",
		selectProductsToLinkToMenu: "Seleccione los productos que desea vincular al menú",
		searchProduct: "Buscar Producto",
		organizedBy: "Organizado por",
		categoryOfProduct: "Categoría del producto",
		searchCategories: "Buscar categorías",
		productsFromAllCategories: "PRODUCTOS DE TODAS LAS CATEGORÍAS",
		productsFromSelectedCategory: "PRODUCTOS DE LA CATEGORÍA SELECCIONADA",
		searchProducts: "Buscar producto",
		selectAllItemsFromCategory: "Seleccionar todos los elementos de la categoría",
		loadingProducts: "Cargando productos...",
		noProductsFound: "Ningún producto encontrado",
		products: "Productos",
		withoutCategory: "Sin categoría",
	},
	allowFichaExport: "Permitir la exportación de fichas.",
	menuConfig: {
		sidebarHeader: "Configuraciones de Menú",
		sidebar: {
			general: {
				title: "Configuración General",
				description: "Habilita y configura las funcionalidades de tu menú digital.",
			},
			branding: {
				title: "Identidad Visual",
				description: "Personaliza los colores, el logo y el banner de este menú.",
			},
			layout: {
				title: "Diseño de Categorías",
				description: "Elige cómo se muestran las categorías en el menú.",
			},
			banners: {
				title: "Banners de Campaña",
				description: "Crea y ordena los banners que se muestran en este menú.",
			},
			featured: {
				title: "Sección Destacada",
				description: "Elige los productos destacados de este menú.",
			},
			qrcode: {
				title: "Código QR y Enlace",
				description: "Copia el enlace y genera el Código QR de tus menús activos",
			},
		},
		sidebarGroups: {
			appearance: "Apariencia",
			content: "Contenido",
			access: "Acceso",
		},
		operationModeSection: {
			title: "Modo de operación",
			description: "Elige el modo de operación del menú digital.",
		},
		modes: {
			vitrine: {
				title: "Modo Vitrina",
				description: "Permite que los clientes solo visualicen el menú",
			},
			posPago: {
				title: "Modo Pospago",
				description:
					"Permite que los clientes paguen en el propio menú después del pedido.",
			},
			prePago: {
				title: "Modo Prepago",
				description: "Permite que los clientes paguen para hacer el pedido.",
			},
		},
		defaultTag: "Predeterminado",
		saveButton: "Guardar configuración",
		saving: "Guardando...",
		saveSuccess: "Configuración guardada con éxito",
		saveError: "No fue posible guardar la configuración",
		brandingSection: {
			title: "Identidad Visual",
			description: "Personaliza cómo se ve este menú para tus clientes.",
			fields: {
				name: "Nombre de visualización",
				logo: "Logo",
				banner: "Portada",
				primaryColor: "Color primario",
			},
			namePlaceholder: "Nombre mostrado en el menú",
			saveButton: "Guardar identidad visual",
			saving: "Guardando...",
			saveSuccess: "Identidad visual guardada con éxito",
			saveError: "No fue posible guardar la identidad visual",
		},
		layoutSection: {
			title: "Diseño de Categorías",
			description: "Elige cómo se muestran las categorías en el menú.",
			defaultTag: "Predeterminado",
			options: {
				tags: {
					title: "Etiquetas",
					description: "Muestra las categorías como una lista de etiquetas desplazable.",
				},
				cards: {
					title: "Tarjetas",
					description: "Muestra las categorías como tarjetas con imagen destacada.",
				},
			},
			saveButton: "Guardar diseño",
			saving: "Guardando...",
			saveSuccess: "Diseño guardado con éxito",
			saveError: "No fue posible guardar el diseño",
		},
	},
};
